module.exports = __webpack_public_path__ + "static/media/masttshaala2026_satprerna_trust.974f66f3.png";